/* eslint-disable-next-line */
import config from 'config/axios.TARGET';

const axiosConfig = {
  ...config,
  timeout: 20000,
};

export default axiosConfig;
